//poll the server and tell it that we're here
function doHeartBeat() {
  var url = getContextPath() + '/eapp/heartbeat/simple';
  $.get(url, function (data) {
    doDebug(data);
  });
}

var timeoutExclusions = new Set([
  '/management/eapp/logoutSuccess',
  '/management/logout',
  '/management/eapp/login',
  '/ehpportal/eapp/logoutSuccess',
  '/ehpportal/logout',
  '/ehpportal/eapp/login'
]);

//timeout is 13 but give user 3 minute warning 10 minutes equal 600000 milliseconds
function doTimeoutHandler() {
  if (!timeoutExclusions.has(location.pathname)) {
    timeoutFunction();
  }
}

function timeoutFunction() {
  var timeoutHandlerStartTime = new Date().getTime();
  var timeoutWarningTime = 600000;
  var timeoutMsTotal = 180000;
  var timeoutDelay = 1000;
  var worker = typeof Worker !== 'undefined' ? startTimeoutWorker() : null;

  $.doTimeout('sessionTimeout', timeoutWarningTime, function () {
    var timeoutModalEl = document.getElementById('timeoutModal');
    if (timeoutModalEl) {
      var timeoutModal = new bootstrap.Modal(timeoutModalEl, {
        backdrop: true,
        keyboard: true
      });
      timeoutModal.show();
      timeoutModalEl.addEventListener(
        'hidden.bs.modal',
        function () {
          doHeartBeat();
          if (typeof $.doTimeout === 'function') {
            $.doTimeout('countdown');
          }
          killWebWorker(worker);
          doTimeoutHandler();
        },
        { once: true }
      );
    }
    //count down
    var timeoutStartTime = new Date().getTime();
    var totalTimeout = timeoutWarningTime + timeoutMsTotal;
    var timeoutMin = 2;
    var timeoutSecs = 60;
    $.doTimeout('countdown', timeoutDelay, function () {
      var pollTime = new Date().getTime();
      var pollStartTimeDiff = pollTime - timeoutHandlerStartTime;

      // to account for browser delay when minimized
      if (pollStartTimeDiff >= totalTimeout) {
        timeoutLogout();
        return false;
      }
      var pollDiff = pollTime - timeoutStartTime;
      var pollMin = Math.floor((timeoutMsTotal + timeoutDelay) / 60000 - pollDiff / 60000);
      pollMin = pollMin > 0 ? pollMin : 0;
      var pollSecs = Math.round((timeoutMsTotal + timeoutDelay) / 1000 - pollDiff / 1000 - pollMin * 60);
      if (pollDiff < timeoutMsTotal && (timeoutMin > 0 || timeoutSecs > 0)) {
        if (timeoutSecs == 0) {
          timeoutSecs = 60;
          timeoutMin--;
        }
        if (timeoutSecs != pollSecs) {
          timeoutSecs = pollSecs;
        }
        if (timeoutMin != pollMin) {
          timeoutMin = pollMin;
        }
        timeoutSecs--;
        $('#time-remains').html(timeoutMin + ':' + (timeoutSecs < 10 ? '0' + timeoutSecs : timeoutSecs));
        return true;
      }
      timeoutLogout();
      return false;
    });
  });
}

function startTimeoutWorker() {
  var worker = new Worker(getContextPath() + '/static/common/js/timeoutWorker.js');
  worker.onmessage = function (event) {
    timeoutLogout();
  };
  return worker;
}

function killWebWorker(worker) {
  if (worker != null) {
    worker.terminate();
  }
}

var oiCSRFToken = $("meta[name='_csrf']").attr('content');

function timeoutLogout() {
  var form = document.createElement('form');
  var element1 = document.createElement('input');

  var url = getContextPath() + '/logout';

  form.method = 'POST';
  form.action = url;
  element1.value = oiCSRFToken;
  element1.name = '_csrf';
  form.appendChild(element1);
  document.body.appendChild(form);
  form.submit();
}

/**
 * Attach Call Me event to links of class 'callMe'
 * (could be called from initOIDoc)
 */
function callMeButtonPopup() {
  // Bootstrap 5 vanilla JS: Add click event listener
  const callMeBtn = document.getElementById('callMe');

  if (callMeBtn) {
    callMeBtn.addEventListener('click', function (e) {
      const dialog = document.getElementById('popup_content');
      const xView = e.pageX - window.pageXOffset;
      const yView = e.pageY - window.pageYOffset;

      if (dialog) {
        dialog.innerHTML = $loading;
        fetch(this.getAttribute('href'))
          .then((response) => response.text())
          .then((html) => {
            dialog.innerHTML = html;
            const modal = new bootstrap.Modal(dialog, {
              backdrop: true,
              keyboard: true
            });
            modal.show();
          })
          .catch((error) => {
            console.error('Error loading Call Me content:', error);
          });
      }
    });
  }

  return false;
}
/**
 * convert the oi:gl tags to glossary links
 */
function convertToGlossaryLinks()
{
	//find any oi:gl or oi:ml tag and turn it into a glossary url
	//<oi:gl key="glo_prescription_drugs">Coverage for Prescription Drugs</oi:gl>
  //<oi:ml key="ede.add_person.help"><i class="fas fa-question-circle"></i> Learn more about who to include.</oi:ml>

  $('oi\\:gl').each(function () {
    var url = getContextPath() + '/eapp/glossarylookup?type=JSON&lookupTerm=' + $(this).attr('key');
    url += '&catalogId=' + oiConfig.catalogId + '&clientId=' + oiConfig.clientId;
    var content =
      '<a tabindex="0" class="iconGlossary" aria-label="Glossary Link" href="' + url + '">' + $(this).html() + '</a>';
    $(this).html(content);
  });

  convertOiMlToLinks();

    $("oi\\:ht").each(function() {
        var url = getContextPath()+"/eapp/messageresourcelookup?type=JSON&key="+$(this).attr('key');
		    var content = $('<a class="iconGlossary" aria-label="Learn More" href="'+url+'">'+$(this).html()+"</a>");
        
		    $(this).html(content);
    });
}

/**
 * load glossary links into popup model
 */
function initGlossaryLinks()
{
    convertToGlossaryLinks();
	//attach glossary event listener to every link that has the icon glossary glass	
	// Use event delegation so dynamically added .iconGlossary elements also get the handler
	$(document).off('click.glossaryLink', '.iconGlossary').on('click.glossaryLink', '.iconGlossary', function(e) {
		e.preventDefault();
		glossaryEventHandler(this);
		return false;
	});

}


function setGlossaryTitle(aPopOverLink){
   return aPopOverLink == null ? "Glossary" : $(aPopOverLink).attr("title");
}

function closeAllPopovers(excludeEl) {
    document.querySelectorAll('.iconGlossary, a[data-bs-title]').forEach(function(el) {
        if (el === excludeEl) return;

        const popover = bootstrap.Popover.getInstance(el);
        popover?.hide();
    });
}

function glossaryEventHandler(aPopOver) {
    // If popover already exists, toggle it (global listener handles closing others)
    const existingPopover = bootstrap.Popover.getInstance(aPopOver);
    if (existingPopover) {
        existingPopover.toggle();
        return;
    }

    // Get href from element
    let lHref = aPopOver.getAttribute("href");

    if (!lHref.includes("type=JSON")) {
        lHref += (lHref.includes("?") ? "&" : "?") + "type=JSON";
    }
    if (!lHref.includes("&clientId=")) {
        lHref += "&clientId=" + oiConfig.clientId;
    }

    fetch(lHref)
        .then(response => response.json())
        .then(data => {
            let title;
            let content;

            if (data.value) {
                const rId = aPopOver.getAttribute('data-responder-id');
                content = typeof replaceSurveyPlaceHolderContent === 'function'
                    ? replaceSurveyPlaceHolderContent(rId, data.value)
                    : data.value;
                title = aPopOver.innerHTML;
            } else {
                title = data.term;
                content = data.definition;
            }

            title = title || '\u00A0'; // Use non-breaking space if title is empty to prevent Bootstrap from hiding the popover

            // Set attributes for Bootstrap 5
            aPopOver.setAttribute("data-bs-title", title);
            aPopOver.setAttribute("data-bs-content", content);
            aPopOver.setAttribute("data-bs-html", "true");

            // Create a Bootstrap 5 Popover instance
            const popover = new bootstrap.Popover(aPopOver, {
                trigger: "click",
                html: true
            });

            // Show the popover
            popover.show();
        })
        .catch(err => console.error("Error loading popover data:", err));
}

/**
 * called when the page renders
 */
function initOIDoc() {
  initGlossaryLinks();

  // Initialize MDB checkbox components for existing content
  // Set in shared-ui/mdb-helpers.js
  initializeMDBComponentsForCheckboxes();
  initializeMDBComponentsForInputs();
  initializeSelects();
  initializeDatePickers();

  //cancel timeout when the button of im still here is clicked
  // Bootstrap 5 vanilla JS: Add click event listener for timeout modal close
  const closeTimeOutBtn = document.getElementById('closeTimeOutModal');
  if (closeTimeOutBtn) {
    closeTimeOutBtn.addEventListener('click', function (e) {
      doHeartBeat();
      if (typeof $.doTimeout === 'function') {
        $.doTimeout('countdown');
      }
      doTimeoutHandler();
    });
  }
  //do timeout notifications as long as we're not on the timeout page
  if (location.pathname.indexOf('/eapp/timeout') == -1) {
    doTimeoutHandler();
  } //end if

  callMeButtonPopup();
}

//IOS click fix
function onClickReplace() {
  (function ($) {
    $.fn.tclick = function (onclick) {
      this.bind('touchstart', function (e) {
        onclick.call(this, e);
        e.stopPropagation();
        e.preventDefault();
      });
      this.bind('click', function (e) {
        onclick.call(this, e);
      }); //substitute mousedown event for exact same result as touchstart
      return this;
    };
  })(jQuery);
}

/**
 * switch the locale when available
 */
function switchLocaleListener() {
  // Bootstrap 5 vanilla JS: Add click event listeners for locale switcher
  document.querySelectorAll('a.swithcLocale').forEach(function (element) {
    element.addEventListener('click', function () {
      const url = this.getAttribute('href');
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          location.reload();
        })
        .catch((error) => {
          console.error('Error switching locale:', error);
        });
      return false;
    });
  });
}

var $loading = '<img src="' + getContextPath() + '/images/loader.gif" alt="loading" />';

// Bootstrap 5 vanilla JS: Document ready replacement
onDocumentReady(function () {
  initOIDoc();
  switchLocaleListener();
  onClickReplace();
  applyCommonInputMasks();

  // Close popovers when clicking outside or when clicking a different glossary link
  document.addEventListener('click', function(e) {
    var clickedGlossary = e.target.closest('.iconGlossary, a[data-bs-title]');
    if (!e.target.closest('.popover')) {
      closeAllPopovers(clickedGlossary);
    }
  });

  //why do we need this?
  // Bootstrap 5 vanilla JS: Add click event listeners for back buttons
  document.querySelectorAll('a.back').forEach(function (element) {
    element.addEventListener('click', function () {
      parent.history.back();
      return false;
    });
  });
});

// Using this over $(".datePickerBasic").daterangepicker so that it will work with dynamically added elements
$('body').on('focus',".datePickerBasic", function(){
    var opts = {
        autoUpdateInput: false, //Don't pre-fill with a default before date selection
        autoApply: true,
        singleDatePicker: true,
        showDropdowns: true,
        minYear: 1901,
        maxYear: 2099,
        drops: 'auto',
    };
    var minDate = $(this).data('min-date');
    var maxDate = $(this).data('max-date');
    if (minDate) { opts.minDate = minDate; }
    if (maxDate) { opts.maxDate = maxDate; }
    $(this).daterangepicker(opts);
});

$('body').on('focus',".datePickerBasicWithRange", function(){
	var opts = {
		autoUpdateInput: false, //Don't pre-fill with a default before date selection
		autoApply: true,
		singleDatePicker: true,
		showDropdowns: true,
		minYear: 1901,
		maxYear: 2099,
		drops: 'auto',
	};
	var minDate = $(this).data('min-date');
	var maxDate = $(this).data('max-date');
	if (minDate) { opts.minDate = minDate; }
	if (maxDate) { opts.maxDate = maxDate; }
	$(this).daterangepicker(opts);
});
// Have to manually update on date selection when autoUpdateInput is off
$('body').on('apply.daterangepicker',".datePickerBasic, .datePickerBasicNoFuture, .datePickerBasicWithRange", function(ev, picker){
	var $input = findInput($(this));
	$input.val(picker.startDate.format('MM/DD/YYYY'));
	$input.change(); // Fixes bootstrap material design floating label not floating
    try {
        var el = $input.get(0);
        if (el) {
            // Dispatch a native input event so Alpine/React/Vue style bindings update
            el.dispatchEvent(new Event('input', { bubbles: true }));
        }
    } catch (e) {
        // no-op
    }
});
// Prevents from picking up future Date of Birth
$('body').on('focus', ".datePickerBasicNoFuture", function () {
    $(this).daterangepicker({
        autoUpdateInput: false,
        autoApply: true,
        singleDatePicker: true,
        showDropdowns: true,
        minYear: 1901,
        maxYear: moment().year(),
        drops: 'auto',
        maxDate: moment()
    });
});
$('body').on('cancel.daterangepicker',".datePickerBasic, .datePickerBasicNoFuture", function(ev, picker){
	findInput($(this)).val('');
});
function findInput($that) {
  if ($that.prop('nodeName') == 'INPUT') {
    var $input = $that;
  } else {
    var $input = $that.closest('.input-group').find('.dateInput');
  }
  if (typeof $input === 'undefined' || $input.prop('nodeName') !== 'INPUT') {
    $input = $that.closest('.input-group').find('input.date');
  }
  return $input;
}

$('.selectpicker').selectpicker({
    style: 'btn-default',
    noneSelectedText: 'Any',
    actionsBox: true,
    liveSearch: true,
    width: "80%",
    container: 'body',
    size: 10
});
$('.selectpickerslim').selectpicker({
    style: 'btn-default',
    noneSelectedText: 'Any',
    dropupAuto: false,
    actionsBox: false,
    liveSearch: false,
    width: "80%",
    size: 5
});
// Bootstrap 5 vanilla JS: Update button classes
document.querySelectorAll('.actions-btn').forEach(function (button) {
  button.classList.remove('btn-light');
  button.classList.add('btn-default');
});

function changeButtonToSpinner(aButton) {
  // disable button
  aButton.prop('disabled', true);
  // disable click event listeners
  aButton.css('pointer-events', 'none');
  // add spinner to button
  aButton.html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Loading...');
}

function changeLinkToSpinner(aLink) {
  // disable button
  aLink.addClass('disabled');
  // add spinner to button
  aLink.html(aLink.html() + ' <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');
}

// Shared whole-number sanitizer used by program-group contribution percent inputs.
(function (global) {
    if (global.OIWholeNumberSanitizer) {
        return;
    }

    function isDigit(key) {
        return /^[0-9]$/.test(key);
    }

    function isControlKey(event) {
        var key = event.key;
        var allowedControlKeys = [
            'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
            'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
            'Home', 'End'
        ];

        if (event.ctrlKey || event.metaKey || event.altKey) {
            return true;
        }

        return allowedControlKeys.indexOf(key) !== -1;
    }

    function sanitizeValue(value) {
        if (value === null || value === undefined) {
            return '';
        }
        return String(value).replace(/[^\d]/g, '');
    }

    function enforceKeydown(event) {
        if (isControlKey(event) || isDigit(event.key)) {
            return;
        }
        event.preventDefault();
    }

    function enforcePaste(event) {
        var pasted = (event.clipboardData || global.clipboardData).getData('text');
        if (!/^\d+$/.test(pasted)) {
            event.preventDefault();
        }
    }

    function sanitizeInputElement(element) {
        element.value = sanitizeValue(element.value);
    }

    global.OIWholeNumberSanitizer = {
        enforceKeydown: enforceKeydown,
        enforcePaste: enforcePaste,
        sanitizeValue: sanitizeValue,
        sanitizeInputElement: sanitizeInputElement
    };
})(window);

// USPS Address Validation singleton (aligned with usps-address-validation2.tag run signature)
(function () {
  if (window.AddressValidation) return;
  window.AddressValidation = (function () {
    let instance = null;
    let ready = false;
    const queue = [];

    function flush() {
      ready = true;
      while (queue.length) {
        try { queue.shift()(); } catch (e) { console.error('AddressValidation queued call failed', e); }
      }
      window.dispatchEvent(new Event('address-validation-ready'));
    }

    return {
      _register(alpineData) {
        if (!instance) {
            instance = alpineData;
            flush();
        } else {
            console.warn('AddressValidation already registered, ignoring:', alpineData);
        }
      },
      isReady() { return ready; },
        open(address, { appContext = '', csrfToken = '' } = {}) {
        return new Promise((resolve, reject) => {
            const exec = () => {
            if (!instance) return reject(new Error('AddressValidation instance missing'));
            if (typeof instance.run === 'function') {
                instance.run(address, appContext, csrfToken, resolve, reject);
            } else {
                reject(new Error('No validation method available'));
            }
            };
            ready ? exec() : queue.push(exec);
        });
        },
      abort() {
        if (instance && instance._abortController) {
          instance._abortController.abort();
        }
      }
    };
  })();
})();
